module.exports = __webpack_public_path__ + "img/3.cb7181b7.jpg";